import { OrganizationDetailsState } from "@idw-types/state/organization-details-state";
import { OrganizationDetailsActionTypes, OrganizationDetailsActions } from "../actions/organization-details-actions";
import { initialIdentityProviderDetailsState } from "@redux/reducers/identity-provider-details-reducer";

export const initialOrganizationDetailsState: OrganizationDetailsState = {
    organization: {
        isLoading: false,
        organization: null
    },
    referenceData: {
        isLoading: false,
        attributeTypeFields: null,
        attributeTypes: null,
        categories: null,
        classifications: null,
        companies: null,
        defaultScheme: null,
        loas: null,
        protocols: null,
        schemes: null,
        urlTypes: null
    }
};

export const organizationDetailsReducer = (
    state: OrganizationDetailsState = initialOrganizationDetailsState,
    action: OrganizationDetailsActions
): OrganizationDetailsState => {
    switch (action.type) {
        case OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_LOADING:
            return {
                ...state,
                organization: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationDetailsState.organization }
                        : { ...state.organization }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS:
            return {
                ...state,
                organization: {
                    organization: action.payload.organizationConfig,
                    isLoading: false
                }
            };

        case OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialIdentityProviderDetailsState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};